import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Trash2, Mail, Phone, ChevronDown, ChevronUp } from 'lucide-react';
import { toast } from 'sonner';
import { formatDate } from '@/lib/utils';

export default function AdminMessages() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expanded, setExpanded] = useState({});

    const load = () => { setLoading(true); api.get('/admin/messages').then(({ data }) => setItems(data)).finally(() => setLoading(false)); };
    useEffect(load, []);

    const onDelete = async (id) => {
        if (!confirm('Obrisati poruku?')) return;
        try { await api.delete(`/admin/messages/${id}`); toast.success('Obrisano'); load(); } catch { toast.error('Brisanje nije uspjelo'); }
    };

    const onMarkRead = async (id) => {
        try { await api.put(`/admin/messages/${id}`, { status: 'read' }); load(); } catch {}
    };

    return (
        <div>
            <h1 className="text-2xl font-medium">Poruke</h1>
            <p className="text-sm text-white/60 mt-1">Poruke iz kontakt forme.</p>

            <div className="mt-6 space-y-3">
                {loading ? <p className="text-white/60">Učitavanje…</p> :
                  items.length === 0 ? <p className="text-white/60">Nema poruka.</p> :
                  items.map((m) => (
                    <Card key={m.id} className="bg-[#111318] border-[#232A36] p-4">
                        <div className="flex items-start justify-between gap-3 flex-wrap">
                            <div className="flex-1">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <h3 className="font-medium">{m.name}</h3>
                                    {m.status === 'new' && <Badge className="bg-[#B08D57] text-white">Novo</Badge>}
                                    <span className="text-xs text-white/50">• {formatDate(m.created_at)}</span>
                                </div>
                                <div className="mt-2 flex gap-4 text-sm text-white/70 flex-wrap">
                                    <a href={`mailto:${m.email}`} className="inline-flex items-center gap-1 hover:text-white"><Mail className="h-3.5 w-3.5" />{m.email}</a>
                                    {m.phone && <a href={`tel:${m.phone}`} className="inline-flex items-center gap-1 hover:text-white"><Phone className="h-3.5 w-3.5" />{m.phone}</a>}
                                </div>
                                {m.subject && <p className="mt-2 text-sm font-medium">Tema: {m.subject}</p>}
                                <p className={`mt-2 text-sm text-white/80 whitespace-pre-wrap ${expanded[m.id] ? '' : 'line-clamp-2'}`}>{m.message}</p>
                                {m.message.length > 200 && (
                                    <Button size="sm" variant="ghost" onClick={() => setExpanded(e => ({...e, [m.id]: !e[m.id]}))} className="mt-1 text-white/60 hover:text-white h-7 px-2 text-xs">
                                        {expanded[m.id] ? <><ChevronUp className="mr-1 h-3 w-3" />Manje</> : <><ChevronDown className="mr-1 h-3 w-3" />Više</>}
                                    </Button>
                                )}
                            </div>
                            <div className="flex gap-2">
                                {m.status === 'new' && <Button size="sm" variant="outline" onClick={() => onMarkRead(m.id)} className="border-[#232A36] text-white hover:bg-[#232A36]">Pročitano</Button>}
                                <Button size="sm" variant="outline" onClick={() => onDelete(m.id)} className="border-red-900 text-red-400 hover:bg-red-900/20"><Trash2 className="h-3.5 w-3.5" /></Button>
                            </div>
                        </div>
                    </Card>
                ))}
            </div>
        </div>
    );
}
